// function myFilters () {
//     var x = document.getElementById('FacetFiltersForm');
//     if (x.style.display === 'none'){
//         x.style.display = 'block';
//     }
//     else {
//         x.style.display = 'none';
//     }
// }

function setFilterState(isVisible) {
  const filterBtn = document.querySelector(".filter-cstm-title");
  const filterBox = document.getElementById("FacetFiltersForm");
  const textSpan = filterBtn?.querySelector(".filter-text");

  if (!filterBtn || !filterBox || !textSpan) return;

  if (isVisible) {
    filterBox.style.display = "block";          
    filterBtn.classList.add("active");
    textSpan.textContent = "Hide Filters";
  } else {
    filterBox.style.display = "none";           
    filterBtn.classList.remove("active");
    textSpan.textContent = "Show Filters";
  }
}
// testing for onload script of tiggle filters
document.addEventListener("DOMContentLoaded", () => {
  const filterBtn = document.querySelector(".filter-cstm-title");
  const filterBox = document.getElementById("FacetFiltersForm");

  if (!filterBtn || !filterBox) return;

  if (window.innerWidth >= 768) {
    setFilterState(false);
    filterBtn.addEventListener("click", () => {
      const isVisible = window.getComputedStyle(filterBox).display === "block";
      setFilterState(!isVisible);
    });
  } else {
    setFilterState(false);
    filterBtn.style.display = "none";
  }
});


// -----------------------------
// document.addEventListener("DOMContentLoaded", function () {
//   const filterBar = document.querySelector(".mobile-facets-cstm");

//   if (!filterBar) return;

//   const filterOffset = filterBar.offsetTop; 

//   window.addEventListener("scroll", function () {
//     let currentScroll = window.pageYOffset;

//     if (currentScroll > filterOffset) {
//       filterBar.classList.add("sticky");
//     } else {
//       filterBar.classList.remove("sticky");
//     }
//   });
// });
// document.addEventListener("DOMContentLoaded", function () {
//   const filterBar = document.querySelector(".deskt-sticky-filters-wrap");

//   if (!filterBar) return;

//   const filterOffset = filterBar.offsetTop; 

//   window.addEventListener("scroll", function () {
//     let currentScroll = window.pageYOffset;

//     if (currentScroll > filterOffset) {
      
//       filterBar.classList.add("sticky");
//     } else {
//       filterBar.classList.remove("sticky");
//     }
//   });
// });
// ++++++++++++++++++++++++++++++++++++++++++


// ------------------------------------
// document.addEventListener("DOMContentLoaded", function () {
//   function makeSticky(selector) {
//     const filterBar = document.querySelector(selector);
//     if (!filterBar) return;

//     const barHeight = filterBar.offsetHeight; // account for bar height
//     const filterOffset = filterBar.offsetTop; 
//     let isSticky = false;

//     window.addEventListener("scroll", function () {
//       let currentScroll = window.pageYOffset;

//       if (currentScroll > filterOffset && !isSticky) {
//         filterBar.classList.add("sticky");
//         filterBar.style.top = "0px"; // prevent layout jump
//         document.body.style.paddingTop = barHeight + "px"; // push page down
//         isSticky = true;
//       } else if (currentScroll <= filterOffset && isSticky) {
//         filterBar.classList.remove("sticky");
//         document.body.style.paddingTop = "0px"; // reset page
//         isSticky = false;
//       }
//     });
//   }

//   makeSticky(".mobile-facets-cstm");
//   makeSticky(".deskt-sticky-filters-wrap");
// });

// ==================================================
// document.addEventListener("DOMContentLoaded", function () {
//   function makeSticky(selector) {
//     const filterBar = document.querySelector(selector);
//     if (!filterBar) return;

//     const header = document.querySelector("header.site-header, .header");
//     const announcement = document.querySelector(".announcement-bar");
//     const bannerWrapper = document.querySelector(".collection-hero__inner");

//     let isSticky = false;
//     const barHeight = filterBar.offsetHeight;

//     function getHeights() {
//       const hdrH = header ? header.offsetHeight : 0;
//       const annH = announcement ? announcement.offsetHeight : 0;
//       return hdrH + annH;
//     }

//     function getBannerBottom() {
//       if (!bannerWrapper) return 0;
//       const rect = bannerWrapper.getBoundingClientRect();
//       return rect.bottom + window.scrollY; // absolute banner bottom position
//     }

//     function handleScroll() {
//       const scrollTop = window.scrollY || window.pageYOffset;
//       const bannerBottom = getBannerBottom();
//       const topOffset = getHeights();

//       // 🔹 Stick when we've scrolled past banner bottom
//       if (scrollTop + topOffset >= bannerBottom && !isSticky) {
//         filterBar.classList.add("sticky");
//         filterBar.style.position = "fixed";
//         filterBar.style.top = topOffset + "px";
//         filterBar.style.left = 0;
//         filterBar.style.right = 0;
//         filterBar.style.zIndex = 9999;
//         document.body.style.paddingTop = barHeight + "px";
//         isSticky = true;
//       } 
//       // 🔹 Unstick when scrolling back up
//       else if (scrollTop + topOffset < bannerBottom && isSticky) {
//         filterBar.classList.remove("sticky");
//         filterBar.style.position = "";
//         filterBar.style.top = "";
//         filterBar.style.left = "";
//         filterBar.style.right = "";
//         filterBar.style.zIndex = "";
//         document.body.style.paddingTop = "0px";
//         isSticky = false;
//       }
//     }

//     window.addEventListener("scroll", handleScroll);
//     window.addEventListener("resize", handleScroll);
//     window.addEventListener("load", handleScroll);
//   }

//   makeSticky(".deskt-sticky-filters-wrap");
//   makeSticky(".mobile-facets-cstm");
// });




 


